exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading[data-v-775b22f8] {\n  background-color: rgba(17, 17, 17, 0.9);\n}\n.loading p[data-v-775b22f8] {\n  background-position: -16px center;\n  background-size: 76px;\n}\n@media screen and (max-width: 420px) and (min-width: 320px) {\n.loading p[data-v-775b22f8] {\n    background-position: -13px center;\n}\n}", ""]);

// exports
